// ================================================================================================
// These should only be used by the store for syncing authenticated session to local storage
// ================================================================================================
import * as sessionStorageEx from 'utils/sessionStorageEx';
import { AuthSession } from './types';

export const loadAuthSession = () => {
  const authSession = sessionStorageEx.getAuthSession();
  if (authSession) {
    return new AuthSession(authSession);
  }
  return new AuthSession();
};

export const saveAuthSession = (authSession) => {

  if (!authSession || authSession.accessToken === null) {
    clearAuthSession();
    return;
  }

  // note: convert to Record before calling toJSON in case we're passed a non-Record object
  const session = new AuthSession(authSession);

  sessionStorageEx.setAuthSession(session);
};

export const clearAuthSession = () => sessionStorageEx.removeAuthSession();
